import _ from 'lodash';

import config from '../config';

const env = config.FLOW_BUILDER_URL;
const envReporting = config.REPORTING_URL;

export default {

  getBotUrl(botId: string) {
    return botId ? `${env}/#/bots/${botId}` : env;
  },

  getCardTemplateUrl(cardTemplateId: string) {
    return cardTemplateId ? `${envReporting}/#/card-templates/list/${cardTemplateId}` : envReporting;
  },

  getFlowUrl(flowId: string, botId: string) {
    return botId && flowId ? `${env}/#/flows/${botId}/${flowId}` : env;
  },

  getViewUrl(viewId: string) {
    return viewId ? `${envReporting}/#/views/${viewId}` : envReporting;
  },

  addQueryParams(url: string, params) {
    return `${url}${_.split(url, '?')[1] ? '&' : '?'}${params}`;
  },

  removeURLParameter(url: string, parameter) {
    const urlparts = _.split(url, '?');
    if (urlparts.length >= 2) {
      const prefix = `${encodeURIComponent(parameter)}=`;
      let pars = _.split(urlparts[1], /[&;]/g);
      //reverse pars as may be destructive
      _.reverse(pars);
      pars = _.filter(pars, param => !_.includes(param, prefix));
      const finalParams = pars.length > 0 ? `?${pars.join('&')}` : '';
      return `${urlparts[0]}${finalParams}`;
    } else {
      return url;
    }
  },

  serializeUrlParameters(obj: Record<string, string | number | boolean>) {
    const str: string[] = [];
    for (const p in obj)
      if (obj[p]) {
        str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
      }
    return str.join('&');
  },
};
